<template>
  <card-panel class="referral-application">
    <div slot="header-name" class="header">
      <referral-application-job-header
        v-if="referredJob"
        :referred-job="referredJob">
      </referral-application-job-header>
      <referral-application-header
        v-else-if="refereeName"
        :referee-name ="refereeName"
        :index="index">
      </referral-application-header>
    </div>

    <referral-application-timeline
      v-if="eventsTimelineConfig.length"
      slot="content"
      :config="eventsTimelineConfig"
      :referee-name="refereeName">
    </referral-application-timeline>
  </card-panel>
</template>

<script>

import CardPanel from 'top20common/components/card-panel/CardPanel';

import ReferralApplicationTimeline from '@/pages/referral/timeline/ReferralApplicationTimeline';

import ReferralApplicationHeader from './ReferralApplicationHeader';
import ReferralApplicationJobHeader from './ReferralApplicationJobHeader';

export default {
  props: {
    referredJob: {type: Object, required: false},
    events: {type: Array},
    index: {type: Number},
    refereeName: {type: String}
  },
  data() {
    return {
      statuses: ['applied', 'shortlisted', 'interview', 'offer', 'hired'],
      finalApplicationStatuses: ['hired', 'dismissed'],
      color: {active: this.$context.colors.secondary, inactive: '#DDD'}
    };
  },
  computed: {
    lastEventIndex() {
      return this.events.length - 1;
    },
    lastEventStatus() {
      return this.events[this.lastEventIndex].application_status;
    },
    eventsTimelineConfig() {
      let timelineConfig = [];

      this.events.map((event, index) => {
        timelineConfig.push({
          badge: this.getBadgeConfig(
            this.color.active,
            index === this.lastEventIndex ? this.color.inactive : this.color.active
          ),
          content: {...event, isActive: true}
        });
      });

      timelineConfig = [...timelineConfig, ...this.configForInactiveEvents];

      return timelineConfig;
    },
    configForInactiveEvents() {
      let inactiveEventsConfig = [];

      if (this.finalApplicationStatuses.indexOf(this.lastEventStatus) === -1) {
        for (let i = this.statuses.indexOf(this.lastEventStatus) + 1; i < this.statuses.length; i++) {
          inactiveEventsConfig.push({
            badge: this.getBadgeConfig(this.color.inactive, this.color.inactive),
            content: {
              referral_status: this.statuses[i],
              application_status: this.statuses[i],
              isActive: false
            }
          });
        }
      }

      return inactiveEventsConfig;
    }
  },
  methods: {
    getBadgeConfig(markerColor = this.color.active, lineColor = this.color.active) {
      return {
        isFilled: true,
        markerColor: markerColor,
        lineColor: lineColor
      };
    }
  },
  components: {
    CardPanel,
    ReferralApplicationHeader,
    ReferralApplicationJobHeader,
    ReferralApplicationTimeline
  }
};
</script>

<style lang="scss">
.referral-application {
  margin-bottom: 30px;

  .header {
    width: 100%;
    padding: 5px 0;
  }
  /deep/ .header-container {
    width: 100%;
  }
}
</style>
